import { Button } from '@material-ui/core';
import { useRouter } from 'next/router';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as shoppingCartActions from '~/store/legacy/actions/shoppingCartActions';
import { SERVICE_TYPE } from '~/constant';
import { useStripe } from '~/hooks/useStripe';
import { selectPayment } from '~/store/legacy/selector/paymentSelectors';
import { selectShoppingCartData } from '~/store/legacy/selector/shoppingCartSelectors';
import { incrementActiveOrders } from '../../models/Orders/useActiveOrdersCount';

const PlaceOrderButton = (props) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const { stripe } = useStripe();
  const { selectedMethod } = useSelector(selectPayment);
  const { serviceType, time, deliveryGroup, isPlacingOrder } = useSelector(selectShoppingCartData);

  const shouldDisablePlaceOrder = () => {
    if (!serviceType) {
      return true;
    }
    if (serviceType === SERVICE_TYPE.DELIVERY) {
      if (!deliveryGroup || !time) {
        return true;
      }
    }
    return !selectedMethod || isPlacingOrder;
  };

  const placeOrder = () => {
    dispatch(shoppingCartActions.placeOrder(router, stripe));
    // This is for the header
    // TODO: it doesn't work great, because the above dispatch takes much longer than the
    // API call that SWR makes to validate the data.
    incrementActiveOrders();
  };

  return (
    <Button
      {...props}
      variant='contained'
      color='primary'
      disabled={shouldDisablePlaceOrder()}
      onClick={placeOrder}
      size='large'>
      Place Order
    </Button>
  );
};

export default PlaceOrderButton;
